import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Culture } from '@/types/culture'
import { ILayers } from '@/types/diagnosis'

interface ILayersTotals {
  min: number
  max: number
}

interface IResults {
  mean: number
  std: number
}

interface FieldWithName {
  name: string
  layers: Record<ILayers, IResults>
}

interface Summary {
  layers: ILayers[]
  totals: Partial<Record<ILayers, ILayersTotals>>
  fields: FieldWithName[]
}

type GetPhysiologicalDiagnosesItem = {
  id: string
  project: {
    id: string
    name: string
  }
  mosaic: {
    date: string
  }
  culture: Culture
  phenological_stage: string
  state_acr?: string
  cicle?: string
  summary: Summary | null
  status: {
    name: string
    status_key: string
    description: string
    label: string
  }
  concluded_at: string
}

export type GetPhysiologicalDiagnosesResponse = GetPhysiologicalDiagnosesItem[]

export const getPhysiologicalDiagnoses = async (
  params?: {
    cicle?: string
    layer?: ILayers
    projectId?: string
  },
  options?: AxiosRequestConfig,
) => {
  const { data } = await companiesApi.get<GetPhysiologicalDiagnosesResponse>(
    apiRoutes.getPhysiologicalDiagnoses('soybean'),
    {
      params,
      ...options,
    },
  )

  return data
}
